
import { defineComponent } from "vue";
import ManageList from "@/components/ManageList.vue";
import store, { AppState, Environment, Feature } from "@/store/app";
import { mapActions, mapGetters, mapState } from "vuex";
import settingsIcon from "@iconify-icons/dashicons/admin-settings";
import uploadIcon from "@iconify-icons/entypo/upload-to-cloud";
import downloadIcon from "@iconify-icons/entypo/download";
import copyIcon from "@iconify-icons/entypo/copy";
import { Icon, InlineIcon } from "@iconify/vue";
import { saveAs } from "file-saver";
import * as clipboard from "clipboard-polyfill/text";

import {
  HostingService,
  HostingStatus,
  HostingStatusType
} from "@/services/hosting.service";

export default defineComponent({
  name: "Sidebar",
  data() {
    return {
      HostingStatusType: HostingStatusType,
      icons: {
        settings: settingsIcon,
        upload: uploadIcon,
        download: downloadIcon,
        copy: copyIcon
      }
    };
  },
  computed: {
    ...mapState("app", ["environments", "features", "hosting"]),
    ...mapState("ui", ["sidebarShowing"]),
    ...mapGetters("app", ["configIsValid", "dataHasChanged"])
  },
  methods: {
    ...mapActions("app", [
      "addEnvironment",
      "removeEnvironment",
      "addFeature",
      "removeFeature"
    ]),
    ...mapActions("ui", ["toggleSidebarShowing", "setSidebarShowing"]),

    goToConfig(event: any) {
      console.log("event", event);
      event.preventDefault();
      this.$router.push("/configuration");
      this.toggleSidebarShowing();
    },
    publishChanges() {
      const appState = (this.$store as any).state.app as AppState;
      const payload = HostingService.formatPayloadFromState(appState);
      HostingService.upload(payload, appState.hosting);
      this.$store.dispatch("app/setExistingFeatures", payload);
    },

    exportJson() {
      const appState = (this.$store as any).state.app as AppState;
      const payload = HostingService.formatPayloadFromState(appState);
      saveAs(
        new Blob([JSON.stringify(payload)], { type: "application/json" }),
        "features.json"
      );
    },

    copyJson() {
      const appState = (this.$store as any).state.app as AppState;
      const payload = HostingService.formatPayloadFromState(appState);
      clipboard.writeText(JSON.stringify(payload, null, 2));

      const currentStatus = (this.$store as any).state.app.hosting.status;

      console.log("current", JSON.parse(JSON.stringify(currentStatus)));

      const message = "Config copied to clipboard.";

      this.$store.dispatch("app/setHostingStatus", {
        message,
        type: HostingStatusType.NORMAL
      } as HostingStatus);

      setTimeout(() => {
        const latestStatus = (this.$store as any).state.app.hosting.status;
        console.log("latest", JSON.parse(JSON.stringify(latestStatus)));
        if (latestStatus.message === message) {
          this.$store.dispatch("app/setHostingStatus", { ...currentStatus });
        }
      }, 3000);
    }
  },
  components: {
    ManageList,
    Icon
  }
});
